<main @fade>
  <nb-card [nbSpinner]="loading">
    <nb-card-header *ngIf="!isModal && editMode === false" i18n="@@Creating"><a [routerLink]="absolutePath">{{ title }}</a> / Добавление</nb-card-header>
    <nb-card-header *ngIf="!isModal && editMode === true" i18n="@@Updating"><a [routerLink]="absolutePath">{{ title }}</a> / {{ editName }}</nb-card-header>

    <nb-card-header *ngIf="deleted"><span i18n="@@RecordDeletedNoTags" class="badge text-bg-secondary">запись удалена</span>
      &nbsp;
      <button *ngIf="deleted" (click)="restore()" i18n-nbTooltip="@@Restore" nbTooltip="Восстановить" nbButton status="control" size="small">
        <nb-icon icon="repeat-outline"></nb-icon>
      </button>
    </nb-card-header>

    <nb-card-body>

      <div class="row">
        <div [ngClass]="isModal ? 'col-lg-12' : 'col-lg-7 n-part-left'">
            <app-create-update-form [base]="this"/>
        </div>
        <div class="col-lg-4" *ngIf="editMode">

          <app-picture [entityPicture]="model.icon" [uri]="uploadIconUri" [pictureField]="pictureField" (pictureEvent)="pictureEvent($event, 'icon')" [title]="'Иконка'" [width]="null"/>

          <app-picture [entityPicture]="model.picture" [uri]="uploadPictureUri" [pictureField]="pictureField" (pictureEvent)="pictureEvent($event)">
            <span i18n="@@CatalogPictureInfo">Размеры 4:3, 320&times;240px&nbsp;min 640&times;480px&nbsp;max, jpeg</span>
          </app-picture>

          <br>
          <app-terms
                     (removeTermEvent)="removeTerm($event)"
                     (insertTermEvent)="insertTerm($event)"
                     [model]="model"></app-terms>
          <br>
          <label>
            <input type="checkbox" [value]="catalogTreeSynonym" (change)="changeCatalogTreeSynonym()">
            {{ catalogTreeSynonymUpdateTitle }}
          </label>
        </div>

      </div>
    </nb-card-body>

  </nb-card>
</main>
